
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import SelectArrowBase from '@/components/atoms/SelectArrowBase.vue'

/**
 * セレクトボタン（プルダウン風）
 */
@Component({
  components: {
    ButtonBase,
    SelectArrowBase,
  },
})
export default class ButtonPulldown extends Vue {
  /** 矢印色指定 */
  @Prop()
  private arrowColor?: string

  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
